import { isEmpty } from 'lodash';
import React from 'react';

export const formatWebhookHistoryData = (data) => {
  return data.map((item, index) => {
    const {
      changes: { url, payload, auth, status, name, emails },
    } = item;
    const children = [] as any;
    let changesText;
    if (
      !isEmpty(payload) ||
      !isEmpty(auth) ||
      !isEmpty(url) ||
      !isEmpty(name) ||
      !isEmpty(emails)
    ) {
      changesText = <a>Edited</a>;
      if (!isEmpty(status)) {
        children.push({
          changes: `Status changed to: ${status}`,
        });
      }
      if (!isEmpty(name)) {
        children.push({
          changes: `Name changed from "${name[0]}" to "${name[1]}"`,
        });
      }
      if (!isEmpty(emails)) {
        children.push({
          changes: `Emails changed from "${emails[0]}" to "${emails[1]}"`,
        });
      }
      if (!isEmpty(url)) {
        children.push({
          changes: (
            <span>
              URL from: {url[0]}
              <br />
              URL to: {url[1]}
            </span>
          ),
        });
      }
      if (!isEmpty(auth)) {
        children.push({
          changes: auth,
        });
      }
      if (!isEmpty(payload)) {
        const {
          alert_type,
          ai_standard_changes,
          ai_changes,
          ma_standard_changes,
          man_changes,
          opt_changes,
        } = payload;
        if (!isEmpty(alert_type)) {
          children.push({
            changes: `Alert type changed from ${payload.alert_type[1]} Alerts to ${payload.alert_type[0]} Alerts`,
          });
        }
        if (!isEmpty(ai_standard_changes)) {
          const { new_alert, old_alert, modified_alert } = ai_standard_changes;
          const optChanges = (
            <>
              <span>AI standard fields changed</span>
              <br />
              {!isEmpty(new_alert) ? (
                <>
                  {`new Key: ${Object.keys(new_alert)
                    .map((key) => `${new_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(old_alert) ? (
                <>
                  {`removed key: ${Object.keys(old_alert)
                    .map((key) => `${old_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(modified_alert) ? (
                <>
                  {`modified: ${Object.keys(modified_alert)
                    .map((key) => `${modified_alert[key][1]} to ${modified_alert[key][0]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}
            </>
          );
          children.push({
            changes: optChanges,
          });
        }
        if (!isEmpty(ai_changes)) {
          const { new_alert, old_alert, modified_alert } = ai_changes;
          const aiChanges = (
            <>
              <span>AI custom fields changed</span> <br />
              <br />
              {!isEmpty(new_alert) ? (
                <>
                  {`new Key: (${Object.entries(new_alert).join('),(')})`}
                  <br />
                </>
              ) : null}
              {!isEmpty(old_alert) ? (
                <>
                  {`removed key: (${Object.entries(old_alert).join('),(')})`}
                  <br />
                </>
              ) : null}
              {!isEmpty(modified_alert) ? (
                <>
                  {`modified: ${Object.keys(modified_alert)
                    .map((key) => `${key}: ${modified_alert[key][1]} to ${modified_alert[key][0]}`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}
            </>
          );
          children.push({
            changes: aiChanges,
          });
        }
        if (!isEmpty(ma_standard_changes)) {
          const { new_alert, old_alert, modified_alert } = ma_standard_changes;
          const optChanges = (
            <>
              <span>Manual standard fields changed</span>
              <br />
              {!isEmpty(new_alert) ? (
                <>
                  {`new Key: ${Object.keys(new_alert)
                    .map((key) => `${new_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(old_alert) ? (
                <>
                  {`removed key: ${Object.keys(old_alert)
                    .map((key) => `${old_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(modified_alert) ? (
                <>
                  {`modified: ${Object.keys(modified_alert)
                    .map((key) => `${modified_alert[key][1]} to ${modified_alert[key][0]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}
            </>
          );
          children.push({
            changes: optChanges,
          });
        }
        if (!isEmpty(man_changes)) {
          const { new_alert, old_alert, modified_alert } = man_changes;
          const manChanges = (
            <>
              <span>Manual custom fields changed</span>
              <br />
              {!isEmpty(new_alert) ? (
                <>
                  {`new Key: (${Object.entries(new_alert).join('),(')})`}
                  <br />
                </>
              ) : null}
              {!isEmpty(old_alert) ? (
                <>
                  {`removed key: (${Object.entries(old_alert).join('),(')})`}
                  <br />
                </>
              ) : null}
              {!isEmpty(modified_alert) ? (
                <>
                  {`modified: ${Object.keys(modified_alert)
                    .map((key) => `${key}: ${modified_alert[key][1]} to ${modified_alert[key][0]}`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}
            </>
          );
          children.push({
            changes: manChanges,
          });
        }
        if (!isEmpty(opt_changes)) {
          const { new_alert, old_alert, modified_alert } = opt_changes;
          const optChanges = (
            <>
              <span>Manual optional fields changed</span>
              <br />
              {!isEmpty(new_alert) ? (
                <>
                  {`new Key: ${Object.keys(new_alert)
                    .map((key) => `${new_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(old_alert) ? (
                <>
                  {`removed key: ${Object.keys(old_alert)
                    .map((key) => `${old_alert[key]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}{' '}
              {!isEmpty(modified_alert) ? (
                <>
                  {`modified: ${Object.keys(modified_alert)
                    .map((key) => `${modified_alert[key][1]} to ${modified_alert[key][0]}(${key})`)
                    .join(', ')}`}
                  <br />
                </>
              ) : null}
            </>
          );
          children.push({
            changes: optChanges,
          });
        }
      }
    } else if (!isEmpty(status)) {
      changesText = status;
    } else null;

    return {
      key: index,
      ...item,
      changes: changesText,
      children,
    };
  });
};
